module.exports = __webpack_public_path__ + "static/beauty-catalogue-section-f37f7a9c402f1de29114b2730cf88acc.png";